<template>
  <div>
    <h2 class="text-center">{{ $store.state.assignmentHeader }}</h2>
    <keep-alive>
      <Overview v-if="$store.state.nav == 'overview'"/>
      <EventSchedule v-if="$store.state.nav == 'event_schedule'"/>
      <EquipmentList v-if="$store.state.nav == 'equipment_list'"/>
      <Finance v-if="$store.state.nav == 'finance'"/>
      <SiteStaff v-if="$store.state.nav == 'site_staff'"/>
      <Downloads v-if="$store.state.nav == 'downloads'"/>
    </keep-alive>
  </div>
</template>

<script>
import Overview from '../components/Assignment/Overview'
import EventSchedule from '../components/Assignment/EventSchedule'
import EquipmentList from '../components/Assignment/EquipmentList'
import Finance from '../components/Assignment/Finance'
import SiteStaff from '../components/Assignment/SiteStaff'
import Downloads from '../components/Assignment/Downloads'

export default {
  components: {
    Overview,
    EventSchedule,
    EquipmentList,
    Finance,
    SiteStaff,
    Downloads
  },
  mounted() {
    const vm = this
    vm.$store.commit('setAssignment', this.$route.params.id)
    vm.$store.commit('setNav', 'overview')
  }
}
</script>